import Header from "../../Header/Header";
import * as S from "../../../shared/style";
import CallBlockerImg from "../../../shared/img/telefon ekran.png";
import React from "react";
import Grow from "@material-ui/core/Grow";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs";
import {useMediaQuery} from "react-responsive";
import CallBlockerMobile from "../../../shared/img/callblocker_mobile.png";
const CallBlocker = () => {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
    if(!isTabletOrMobile) {
        return (
            <>
                <Header/>
                <Breadcrumbs site="Call Blocker"></Breadcrumbs>
                <Grow in={3300}>
                    <S.PhoneContainer>
                        <S.TitleContainer><S.Title FontColor={"#00a8ff"}>Call Blocker</S.Title></S.TitleContainer>
                        <S.TitleContainer>
                            <p>Możliwość blokowania/odblokowania połączeń spoza listy kontaktów /
                                zastrzeżonych/płatnych.</p>
                        </S.TitleContainer>
                        <S.Phone width={"600px"} MarginRight={"200px"}
                                 alt={"Zdjęcie przedstawia telefon z funkcjami CodeRed"} src={CallBlockerImg}/>
                    </S.PhoneContainer>
                </Grow>
            </>
        );
    }else{
        return(
            <>
                <Header/>
                <Breadcrumbs site="Call Blocker"></Breadcrumbs>
                <Grow in={3300}>
                    <S.PhoneContainer>
                        <S.TitleContainer><S.Title FontColor={"#00a8ff"}>Call Blocker</S.Title></S.TitleContainer>
                        <S.TitleContainer>
                            <p>Możliwość blokowania/odblokowania połączeń spoza listy kontaktów /
                                zastrzeżonych/płatnych.</p>
                        </S.TitleContainer>
                        <S.Phone width={"600px"}
                                 alt={"Zdjęcie przedstawia telefon z funkcjami CodeRed"} src={CallBlockerMobile}/>
                    </S.PhoneContainer>
                </Grow>
            </>
        )
    }
}

export default CallBlocker;